import React from 'react';
import ChesssLogo from '../../images/chessslogo.png';

const friendsList = [
  { id: 1, username: 'Friend 1', image: 'path/to/image1.jpg' },
  { id: 2, username: 'Friend 2', image: 'path/to/image2.jpg' },
  { id: 3, username: 'Friend 3', image: 'path/to/image3.jpg' },
  { id: 4, username: 'Friend 4', image: 'path/to/image3.jpg' },
  // Add more friends as needed
];

const publicMessage = [
  { id: 1, username: 'Friend 1', message: 'this is a constant' },
  { id: 2, username: 'Friend 2', message: 'testing' },
  { id: 3, username: 'Friend 3', message: 'yo' },
  { id: 4, username: 'Friend 4', message: 'sup nerd' },
  // Add more friends as needed
];

const friends = () => {
  return (
    <div className="app-container">
         <div className="explore-container main-column">
        <div class="two-column-container">
          <div style={{ display: 'flex', flexDirection: 'column', width: '50%'}}>

          <div style={{ color: 'white', fontSize: '22px', textAlign: 'left', marginTop: '10px' }}>Friends Online</div>
        
        <div className="friends-list" style={{ marginTop: '25px' }}>
          {friendsList.map(friend => (
            <div key={friend.id} className="friend-block" style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', borderTop: '2px solid gray', paddingTop: '5px' }}>
              <div className="friend-image" style={{ width: '50px', height: '50px', borderRadius: '50%', overflow: 'hidden', marginRight: '20px' }}>
                <img src={ChesssLogo} alt={friend.username} style={{ width: '100%', height: '100%' }} />
              </div>
              <div><i style={{ color: '#ff0000', marginRight: '10px' }} class="fa-solid fa-circle"></i></div>
              <div className="friend-username" style={{ flexGrow: 1, color: 'white', fontSize: '18px' }}>
                {friend.username}
              </div>
              <div className="friend-actions" style={{ display: 'flex', gap: '10px' }}>
                <button className="friend-action-button" style={{ padding: '10px', backgroundColor: '#3b5998', color: 'white', border: 'none', borderRadius: '5px' }}>Message</button>
                <button className="friend-action-button" style={{ padding: '10px', backgroundColor: '#3b5998', color: 'white', border: 'none', borderRadius: '5px' }}>Watch</button>
                <button className="friend-action-button" style={{ padding: '10px', backgroundColor: '#3b5998', color: 'white', border: 'none', borderRadius: '5px' }}>Challenge</button>
              </div>
            </div>
            
          ))}




      </div>
        
      

      </div>

      <div style={{ display: 'flex', flexDirection: 'column', width: '50%'}}>
      <div style={{ color: 'white', fontSize: '22px', textAlign: 'left', marginTop: '10px' }}>Search</div>
      <div style={{ color: 'white', fontSize: '22px', textAlign: 'left', marginTop: '10px' }}>Barcode etc.</div>
      <div style={{ color: 'white', fontSize: '22px', textAlign: 'left', marginTop: '10px' }}>Messages</div>
        
        <div className="main-column" style={{ height: '250px', backgroundColor: 'gray' }}>
        <div>TEST</div>
        <div>TEST</div>


        </div>
          </div>

      </div>
      </div>
    </div>
  );
};

export default friends;
